(ns frontend.view.components.spinner
  (:require
   [common.localization :as loc]
   [frontend.bootstrap.components :as rbs]))

(def min-spinner-timeout 500)

(defn view
  []
  [rbs/Image
   {:src        "/img/spinner.gif"
    :width      "40px"
    :fluid      "fluid"
    :class-name "center-block"}])

(defn loading
  []
  [:div
   {:class "h-screen w-full flex gap-8 flex-col items-center justify-center bg-base-light"}
   [:img
    {:src   "/img/Spinning-arrow.gif"
     :class "max-w-[300px]"}]

   [:span (loc/tr :loading)]])


(defn module-loading
  []
  [:div
   {:class "h-screen w-full flex gap-8 flex-col items-center justify-center bg-base-light"}
   [:img
    {:src   "/img/Spinning-arrow.gif"
     :class "max-w-[300px]"}]

   [:span (loc/tr :loading)]])
